import { Button, Card } from 'antd';
import PermissionsWrapper from 'app/components/PermissionsWrapper/PermissionsWrapper';
import { selectIsConsultant } from 'app/containers/Authorization/slice/selectors';
import { selectSelectedEnvId } from 'app/containers/HiikoEnv/slice/selectors';
import { PermissionsEnum } from 'app/containers/User/slice/types';
import { RouteConstants } from 'app/routes';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { generatePath, useHistory } from 'react-router-dom';
import { useResponsiveQuery } from 'utils/responsiveQuery/useResponsiveQuery';
import TaskListTable from '../../../../parts/TaskListTable/TaskListTable';
import { useTaskSlice } from '../../../../slice';
import { selectTaskListState } from '../../../../slice/selectors';
import { ITaskFilters, TaskListSort } from '../../../../slice/types';

interface IProps {}

const TaskListCard: FC<IProps> = () => {
  const { t } = useTranslation();

  const history = useHistory();

  const { mobileOrTablet } = useResponsiveQuery();

  const { actions } = useTaskSlice();

  const dispatch = useDispatch();

  const envId = useSelector(selectSelectedEnvId) as number;
  const taskListState = useSelector(selectTaskListState);
  const isConsultant = useSelector(selectIsConsultant);

  const setFilters = (filters: ITaskFilters) => {
    dispatch(actions.setTaskListFilters(filters));
  };

  const setCurrentPage = (page: number) => {
    dispatch(actions.setTaskListCurrentPage(page));
  };

  const setSort = (payload: TaskListSort) => {
    dispatch(actions.setTaskListSort(payload));
  };

  return (
    <Card
      title={t('Task.List.TaskList', 'Task list')}
      bordered={false}
      bodyStyle={{
        paddingLeft: mobileOrTablet ? 6 : undefined,
        paddingRight: mobileOrTablet ? 6 : undefined,
        height: mobileOrTablet ? undefined : 'calc(100vh - 230px)',
        overflow: 'hidden',
      }}
      extra={
        <PermissionsWrapper
          key="0"
          requiredEditPermissions={[PermissionsEnum.taskAdministration]}
        >
          <Button
            onClick={() =>
              history.push(
                generatePath(RouteConstants.task.createTask, {
                  envId,
                }),
              )
            }
            type="primary"
          >
            {isConsultant
              ? t('Task.CreateRecommendation', 'Create recommendation')
              : t('Task.List.CreateTask', 'Create task')}
          </Button>
        </PermissionsWrapper>
      }
    >
      <TaskListTable
        taskListState={taskListState}
        setFilters={setFilters}
        setCurrentPage={setCurrentPage}
        setSort={setSort}
      />
    </Card>
  );
};

export default TaskListCard;
